import useIframeZoom from '@hooks/useIframeZoom'
import { Box } from '@mui/joy'
import { useIsAppControl } from '@store/isApp'
import { theme } from '@ui/style'
import pxToRem from '@utils/pxToRem'
import setAds from '@utils/setAds'
import { useLayoutEffect } from 'react'
import AsideAdWrapper from '@components/ads/Article/Aside/AsideAdWrapper'
import useIsShowAds from '@hooks/ads/useIsShowAds'

const BodyImgMoAd = () => {
	const { isApp } = useIsAppControl()
	const { iframeStyles } = useIframeZoom()
	const { isShowMobile } = useIsShowAds()

	const isShowAd = !isApp && isShowMobile

	useLayoutEffect(() => {
		if (!isShowAd) {
			return
		}

		setAds({
			id: 'fqbX6G_SR5C6m44GTaczJw',
			inventory: 'jtbc_m/article_news/article_news@news_article_336x280?mlink=547',
		})
	}, [isShowAd])

	return (
		<AsideAdWrapper
			sx={{
				display: isShowAd ? 'block' : 'none',
				marginTop: { xs: pxToRem(40), md: 0 },
			}}
		>
			<Box
				display={{ xs: 'block', md: 'none' }}
				id="fqbX6G_SR5C6m44GTaczJw_AD"
				sx={{
					'&>div': {
						[theme.mediaQueries.under.origin]: {
							width: `${pxToRem(336)}!important`,
							height: `${pxToRem(280)}!important`,
							overflow: 'hidden',
							'&>iframe': iframeStyles,
						},
					},
				}}
			/>
		</AsideAdWrapper>
	)
}
export default BodyImgMoAd
